import * as React from "react";

export const IconPower = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_6252_38058)">
			<path
				d="M13.3417 5.83333L13.3333 2.5L11.6667 2.5V5.83333L8.33333 5.83333V2.5H6.66667V5.83333H6.65833C5.83333 5.825 5 6.65833 5 7.49167L5 12.0667L7.91667 15V17.5H12.0833L12.0833 15L15 12.075L15 7.49167C15 6.65833 14.1667 5.825 13.3417 5.83333Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_6252_38058">
				<rect width="20" height="20" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
